import {Injectable} from '@angular/core';
import {BehaviorSubject, catchError, Observable, of} from 'rxjs';
import {environment} from '../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from "@angular/router";
import {UserInfo} from "./me/user.service";

enum AuthProcess {
  LOGIN = 'login',
  CONNECT = 'connect'
}

export interface SessionResponse {
  status: number;
  data: {
    user: UserInfo;
    method: object[];
  };
  meta: {
    is_authenticated: boolean;
  };
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private _isAuthenticated = new BehaviorSubject<boolean>(false);
  private _user = new BehaviorSubject<UserInfo|null>(null);

  constructor(private cookieService: CookieService,
              private http: HttpClient,
              private router: Router) {
    this.getSession();
  }

  isAuthenticated(): BehaviorSubject<boolean> {
    return this._isAuthenticated;
  }

  getUser(): Observable<UserInfo|null> {
    return this._user;
  }

  logout() {
    const headers = new HttpHeaders({ 'X-CSRFToken': this.cookieService.get('csrftoken')});
    this.http.delete<SessionResponse>(`${environment.backend.baseUrl}/_allauth/browser/v1/auth/session`, {withCredentials: true, headers: headers})
      .pipe(
        catchError(err => of(err.error as SessionResponse))
      )
      .subscribe((response: SessionResponse) => {
        this._isAuthenticated.next(response.meta.is_authenticated);
        this._user.next(response.data.user);
      });
    this.router.navigate(['/']);
  }

  private getSession(): void {
    this.http.get<SessionResponse>(`${environment.backend.baseUrl}/_allauth/browser/v1/auth/session`, {withCredentials: true})
      .pipe(
        catchError(err => of(err.error as SessionResponse)) //allauth will return a 401 on successful logout.
      )
      .subscribe((response: SessionResponse) => {
        this._isAuthenticated.next(response.meta.is_authenticated);
        this._user.next(response.data.user);
      });
  }

  // TODO(ML): Use actual form here instead of JS'ing it
  async login() {
    this.postForm(`${environment.backend.baseUrl}/_allauth/browser/v1/auth/provider/redirect`, {
      provider: environment.backend.authProviderId,
      process: AuthProcess.LOGIN,
      callback_url: environment.backend.authCallbackUrl,
      csrfmiddlewaretoken: this.cookieService.get(environment.backend.csrfCookieName),
    });
  }

  postForm (action: string, data: any) {
    const f = document.createElement('form')
    f.method = 'POST'
    f.action = action

    for (const key in data) {
      const d = document.createElement('input')
      d.type = 'hidden'
      d.name = key
      d.value = data[key]
      f.appendChild(d)
    }
    document.body.appendChild(f)
    f.submit()
  }
}

